export const ROUTES ={
    HOME: '/',
    POPULAR:'/popular',
    TOPRATED:'/toprated',
    NOWPLAYING:'/nowplaying',
    FAVORITES:'/favorites',
    SHOW: '/show/'
}